import React from 'react';
import type { ComponentProps } from 'react';

import { createFeatureFlagProvider } from '@reckon-web/feature-flags';

import { Config } from '../../services/Config';
import { useAuthenticatedUser } from '../../services/Auth';

import { BookSetupWizardDefaultFeatureFlagContext } from './BookSetupWizardFeatureFlagContext';
import { BookSetupWizardDefaultFeatureFlag } from './BookSetupWizardDefaultFeatureFlag';

const FeatureFlagProvider = createFeatureFlagProvider(
  'Platform',
  Config.APPLICATION_LAUNCH_DARKLY_APPID,
  /**
   * As we don't have default feature flag
   */
  BookSetupWizardDefaultFeatureFlag,
  BookSetupWizardDefaultFeatureFlagContext
);

type BookSetupWizardFeatureFlagProviderProps = ComponentProps<
  typeof FeatureFlagProvider
>;

export function BookSetupWizardFeatureFlagProvider({
  children,
}: BookSetupWizardFeatureFlagProviderProps) {
  const authenticatedUser = useAuthenticatedUser();

  const defaultUser = authenticatedUser.user
    ? {
        anonymous: false,
        user_id: authenticatedUser.user.id,
        /**
         * Can be left blank for Book setup
         */
        book_id: '',
        tenancy_id: 'RECKON',
        /**
         * Can be left blank for Book setup as it is not required
         */
        portal_company_id: '',
        /**
         * Default to epoch 0 as book setup doesn't have a book yet
         */
        book_creation_date: 0,
        host: typeof window === 'undefined' ? 'unknow' : window.location.host,
      }
    : undefined;

  return (
    <FeatureFlagProvider defaultUser={defaultUser}>
      {children}
    </FeatureFlagProvider>
  );
}
